import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

export default function PetFriendlyIcon({ color = "gray" }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M12 14C12.8 14 13 13.3333 13 13H11C11 13.3333 11.2 14 12 14ZM12 14V15M12 15C12 15.6667 12.4 17 14 17C15.6 17 16 15.6667 16 15M12 15C12 15.6667 11.6 17 10 17C8.4 17 8 15.6667 8 15M15 10V10.01M9 10V10.01M4 3V13C4 15.6667 5.6 21 12 21C18.4 21 20 15.6667 20 13V3L16.5 6.5L14.5298 5.84327C12.8877 5.2959 11.1123 5.2959 9.47018 5.84327L7.5 6.5L4 3Z"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
